import { validateSequenceSchema } from '@pasqal-io/pulser-schema';
import { Err } from 'ts-results';
import { catchValidation } from '~/util/validation';
import { validatePulserSequence } from './validation';
import type { PulserSequence } from './types';
import type { Result } from 'ts-results';
import type { ValidationError } from '~/util/validation';
export * from './types';
export { formatSequenceError } from '@pasqal/core/ui/components/pulser-studio/models/pulser-schema';

export type AJVError = {
  instancePath: string;
  schemaPath: string;
  keyword: string;

  params: any;
  message: string;
};

export type PulserSchemaError = AJVError[];

/**
 * Import and validate a pulser sequence from unknown JS object.
 *
 * Safe to use on unknown object straight after JSON parsing.
 */
export function parsePulserSequence(
  jsValue: unknown
): Result<PulserSequence, ValidationError | PulserSchemaError> {
  // 1. validate the sequence against the Pulser schema
  if (!validateSequenceSchema(jsValue)) {
    return Err(validateSequenceSchema.errors as PulserSchemaError);
  }

  return catchValidation(() => {
    // 2. validate the internal consistency of the sequence
    // (ex: no use of undeclared variable, no out of range atom index, etc.)
    validatePulserSequence(jsValue as PulserSequence);
    return jsValue as PulserSequence;
  });
}
